// extracted by mini-css-extract-plugin
module.exports = {"root":"LandingNewsletterHeader_root__OUTCX","logo":"LandingNewsletterHeader_logo__PH8EM","rotation":"LandingNewsletterHeader_rotation__mXMsO"};